import { Navigation } from "./Navigation";
import { SecurityBadge } from "./SecurityBadge";
import { ShareButton } from "./ShareButton";
import { useLocationConsent } from "@/hooks/useLocationConsent";
import { PerformanceBanner } from "./PerformanceBanner";

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const { LocationConsentModal } = useLocationConsent();

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <PerformanceBanner />
      <main>{children}</main>
      <LocationConsentModal />

      <footer className="border-t border-border py-8 bg-card">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-8">
            <div>
              <h3 className="font-semibold mb-3 text-foreground">Tools</h3>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li><a href="/games" className="hover:text-primary transition-colors">Games</a></li>
                <li><a href="/numbers" className="hover:text-primary transition-colors">Numbers</a></li>
                <li><a href="/lists" className="hover:text-primary transition-colors">Lists</a></li>
                <li><a href="/drawings" className="hover:text-primary transition-colors">Drawings</a></li>
                <li><a href="/web-tools" className="hover:text-primary transition-colors">Web Tools</a></li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold mb-3 text-foreground">Information</h3>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li><a href="/blog" className="hover:text-primary transition-colors">Knowledge Center</a></li>
                <li><a href="/about" className="hover:text-primary transition-colors">About Us</a></li>
                <li><a href="/learn-more" className="hover:text-primary transition-colors">How It Works</a></li>
                <li><a href="/faq" className="hover:text-primary transition-colors">FAQ</a></li>
                <li><a href="/testimonials" className="hover:text-primary transition-colors">Testimonials</a></li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold mb-3 text-foreground">Education</h3>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li><a href="/education/primary-school" className="hover:text-primary transition-colors">Primary Schools</a></li>
                <li><a href="/education/high-school" className="hover:text-primary transition-colors">High Schools</a></li>
                <li><a href="/education/university" className="hover:text-primary transition-colors">Universities</a></li>
                <li><a href="/education/college" className="hover:text-primary transition-colors">College</a></li>
                <li><a href="/education/homeschool" className="hover:text-primary transition-colors">Homeschool</a></li>
                <li><a href="/education/adult-learning" className="hover:text-primary transition-colors">Adult Learning</a></li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold mb-3 text-foreground">Legal</h3>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li><a href="/privacy" className="hover:text-primary transition-colors">Privacy Policy</a></li>
                <li><a href="/privacy-settings" className="hover:text-primary transition-colors">Privacy Settings</a></li>
                <li><a href="/terms" className="hover:text-primary transition-colors">Terms of Service</a></li>
                <li><a href="/contact" className="hover:text-primary transition-colors">Contact</a></li>
                <li><a href="/sitemap" className="hover:text-primary transition-colors">Sitemap</a></li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold mb-3 text-foreground">Connect</h3>
              <p className="text-sm text-muted-foreground">
                Stay updated with the latest features and updates.
              </p>
            </div>
          </div>
          <div className="border-t border-border pt-6 text-center text-sm text-muted-foreground">
            <p className="mb-2">
              Using crypto.getRandomValues() for cryptographically secure random generation
            </p>
            <p>© {new Date().getFullYear()} RandomGen. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};
